import React from 'react';
import { connect } from 'react-redux';

import type { RootState } from '@swf/core/store';
import { select } from '@swf/core/store';

import type { Props as TranslationProps } from './Translation';
import Translation from './Translation';

interface OwnProps {
  include?: number[];
  exclude?: number[];
}

interface StateProps {
  license: number;
}

export type Props = OwnProps & TranslationProps & StateProps;

class LicensedTranslation extends React.PureComponent<Props> {
  render() {
    let shouldShow = true;
    const { include, exclude, license, ...translationProps } = this.props;

    if (include?.length) {
      shouldShow = include.includes(license);
    } else if (exclude?.length) {
      shouldShow = !exclude.includes(license);
    }

    return shouldShow && <Translation {...translationProps} />;
  }
}

const mapState = (rootState: RootState) => ({
  license: select.account.getLicense(rootState)
});

// @ts-ignore https://github.com/DefinitelyTyped/DefinitelyTyped/issues/31363
export default connect(mapState)(LicensedTranslation);
